import api from './api';

export const nasService = {
  // Pobierz wszystkie urządzenia NAS
  getNASDevices: async () => {
    const response = await api.get('/nas/devices');
    return response.data;
  },

  // Pobierz foldery urządzenia NAS
  getFolders: async (deviceId) => {
    const response = await api.get(`/nas/${deviceId}/folders`);
    return response.data;
  },

  // Skanuj foldery na urządzeniu NAS
  scanFolders: async (deviceId) => {
    const response = await api.post(`/nas/${deviceId}/scan-folders`);
    return response.data;
  },

  // Mapuj dysk NAS
  mapDrive: async (deviceId, folderId, driveLetter) => {
    const response = await api.post(`/nas/${deviceId}/map-drive`, {
      folderId,
      driveLetter
    });
    return response.data;
  },

  // Odmapuj dysk NAS
  unmapDrive: async (deviceId, folderId) => {
    const response = await api.post(`/nas/${deviceId}/unmap-drive`, {
      folderId
    });
    return response.data;
  },

  // Pobierz wszystkie zmapowane dyski
  getMappedDrives: async () => {
    const response = await api.get('/nas/mapped-drives');
    return response.data;
  },

  // Testuj połączenie z urządzeniem NAS
  testConnection: async (connectionData) => {
    const response = await api.post('/nas/test-connection', connectionData);
    return response.data;
  },

  // Przeglądaj zawartość folderu
  browseFolder: async (deviceId, folderPath = '/') => {
    const encodedPath = encodeURIComponent(folderPath);
    const response = await api.get(`/nas/${deviceId}/browse/${encodedPath}`);
    return response.data;
  },

  // Wyślij plik do folderu na NAS
  uploadFile: async (deviceId, folderPath, fileName, fileData) => {
    const response = await api.post(`/nas/${deviceId}/upload`, {
      folderPath,
      fileName,
      fileData
    });
    return response.data;
  },

  // Przypisz dostęp do folderu
  assignFolderAccess: async (deviceId, folderPath, permissions) => {
    const response = await api.post(`/folder-access/${deviceId}/assign`, {
      folderPath,
      folderName: folderPath.split('/').pop(),
      permissions
    });
    return response.data;
  }
};
